/** @format */

import React from "react";
import { LogoLink } from "../components/logo/LogoLink";
import { Content } from "../components/content/Content";
import { Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DisplacementSphere from "../components/background/DisplacementSphere";
import { ThemeToggle } from "../components/theme/ThemeToggle";
import { Resume } from "../components/resume/Resume";
import { SocialIcons } from "../components/content/SocialIcons";
import { SpeedDials } from "../components/speedDial/SpeedDial";
import { SideNavbar } from "../components/nav/SideNavbar";
import { Works } from "../components/works/Works";
import { About } from "../components/about/About";
import { Contact } from "../components/contact/Contact";
import { Today } from "../components/content/Today";
import { useDispatch, useSelector } from "react-redux";
import { getTimeStamps } from "../action/notesActions";
import { useEffect } from "react";
import { Tooltip, Zoom } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
}));

export const Home = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const TimeStamp = useSelector((state) => state.TimeStamps);
  const { TimeStamp: TimeStamps } = TimeStamp;
  useEffect(() => {
    dispatch(getTimeStamps());
  }, [dispatch]);

  let timestamp = TimeStamps?.updatedAt;
  let accountUpdatedAt;

  function dateFormat(date) {
    const month = date.getMonth();
    const day = date.getDate();
    const monthString = month >= 10 ? month : `0${month}`;
    const dayString = day >= 10 ? day : `0${day}`;
    return `${date.getFullYear()}-${monthString}-${dayString}`;
  }
  if (timestamp) {
    let c = new Date(timestamp);
    accountUpdatedAt = dateFormat(c);
    console.log(accountUpdatedAt);
  } else console.log(timestamp);
  return (
    <>
      <div className={classes.root} id="home">
        <wc-toast position="bottom-left"></wc-toast>

        <DisplacementSphere />
        <LogoLink />
        <Content />
        <ThemeToggle />
        <Hidden smDown>
          <SocialIcons />
        </Hidden>
        <Hidden mdUp>
          <SpeedDials />
        </Hidden>
        <Resume />
      </div>
      <SideNavbar />
      <Works />
      <About />
      <Contact />
      <Today />

      <Tooltip
        title={accountUpdatedAt ? accountUpdatedAt : "Error Occured"}
        placement="right"
        TransitionComponent={Zoom}
      >
        <div
          style={{
            padding: "4px 6px 2px 7px",
            background: "#96969682",
            borderRadius: "31px",
            backdropFilter: "blur(10px)",
            position: "fixed",
            bottom: "10px",
            right: "7px",
            fontSize: "12px",
          }}
        >
          Recently Updated On :{" "}
          {accountUpdatedAt ? accountUpdatedAt : "Loading.."}
        </div>
      </Tooltip>
    </>
  );
};
